import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import MenuSection from "@/components/MenuSection";
import Gallery from "@/components/Gallery";
import Localisation from "@/components/Localisation";
import Horaires from "@/components/Horaires";
import Footer from "@/components/Footer";
import FloatingPhone from "@/components/FloatingPhone";

function Home() {
  return (
    <div className="App" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <MenuSection />
        <Gallery />
        <Localisation />
        <Horaires />
      </main>
      <Footer />
      <FloatingPhone />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
